import React, { useEffect, useState } from "react";
import { getMaintenances } from "../../../api/workOrderApi";
import { USER_SO_KEY } from "../../../utils/accountUtils";
import { getSessionStorage } from "../../../utils/StorageUtil";
import moment from "moment";
import { DataGridPremium } from "@asf-libs/x-data-grid-premium";
import { Box, CircularProgress } from "@mui/material";
import ProfileHeader from "../../../components/ProfileHeader";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import ProfileContext from "../profile/ProfileContext";

const WorkOrdersDesktop = () => {
  const user = getSessionStorage(USER_SO_KEY);
  const role = user?.role;
  const companyName = user?.company?.name;

  const [workOrders, setWorkOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const allowedRoles = ["DIRECTORIO", "ADMINISTRATIVO", "RESPONSABLE_FLOTA"];

  useEffect(() => {
    const fetchWorkOrders = async () => {
      try {
        const res = await getMaintenances();
        if (res.status) {
          const filtered = res.json.filter((m) => {
            if (["DIRECTORIO", "ADMINISTRATIVO"].includes(role)) return true;

            if (role === "RESPONSABLE_FLOTA") {
              const empresaOT = m.remarks?.trim().toUpperCase();
              const unitStatus = m.unit?.unitStatus;
              const perfilEmpresa = companyName?.trim().toUpperCase();
              return empresaOT === perfilEmpresa && unitStatus === "ALQUILADO";
            }

            return false;
          });
          setWorkOrders(filtered);
        }
      } catch (err) {
        console.error("Error fetching work orders", err);
      } finally {
        setLoading(false);
      }
    };

    if (allowedRoles.includes(role)) {
      fetchWorkOrders();
    } else {
      setLoading(false);
    }
  }, [role, companyName]);

  const filteredWorkOrders = workOrders.filter((item) =>
    item.description?.toLowerCase().includes(filter.toLowerCase())
  );

  const columns = [
    { field: "description", headerName: "Dominio", flex: 1 },
    {
      field: "model",
      headerName: "Modelo",
      flex: 1,
      valueGetter: (params) => params.row.unit?.unitType?.model || "-",
    },
    {
      field: "status",
      headerName: "Estado",
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            fontWeight: "bold",
            color: params.value === "FINALIZADA" ? "green" : "orange",
          }}
        >
          {params.value || "N/A"}
        </span>
      ),
    },
    {
      field: "finishDate",
      headerName: "Fin estimado",
      flex: 1,
      valueGetter: (params) =>
        params.row.finishDate
          ? moment(params.row.finishDate).format("DD/MM/YYYY")
          : "No definido",
    },
    { field: "idMaintenance", headerName: "ID", flex: 1 },
    { field: "type", headerName: "Tipo", flex: 1 },
    { field: "remarks", headerName: "Empresa", flex: 1 },
    {
      field: "deliveryDate",
      headerName: "Fecha",
      flex: 1,
      valueGetter: (params) =>
        params.row.deliveryDate
          ? moment(params.row.deliveryDate).format("DD/MM/YYYY")
          : "N/A",
    },
    { field: "detail", headerName: "Detalle", flex: 2 },
    {
      field: "ticket",
      headerName: "Ticket",
      flex: 1,
      valueGetter: (params) =>
        params.row.ticket ? params.row.ticket.idTicket : "Sin ticket",
    },
  ];

  return (
    <ProfileContext.Consumer>
      {() => (
        <Box sx={{ background: "#F2F3F1", mb: "20px" }}>
          <ProfileHeader />

          <Box sx={{ margin: "0 4%" }}>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "70vh",
                }}
              >
                <CircularProgress size={80} thickness={4} />
              </Box>
            ) : !workOrders.length ? (
                  <p>No hay órdenes de trabajo disponibles.</p>
                ) : (

              <Box
                borderRadius={5}
                sx={{
                  background: "#FFFFFF",
                  height: "80vh",
                  pt: 2,
                  pb: 2,
                }}
              >
                <h2 style={{ marginLeft: "20px" }}>Órdenes de Trabajo</h2>

                <input
                  type="text"
                  placeholder="Filtrar por dominio..."
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  style={{
                    margin: "20px",
                    padding: "6px",
                    width: "250px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />

                <DataGridPremium style={{ marginBottom: "20px" }}
                  rows={filteredWorkOrders}
                  columns={columns}
                  getRowId={(row) => row.idMaintenance}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[10, 25, 50]}
                  disableRowSelectionOnClick
                />
              </Box>
            )}
          </Box>
          <ProfileBottomNav goBack={true} />
        </Box>
      )}
    </ProfileContext.Consumer>
  );
};

export default WorkOrdersDesktop;
